


































import {Component, Vue} from "vue-property-decorator";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";
import ClickOutside from 'vue-click-outside'
import {bus} from "@/plugins/bus";
import { EventEmitter } from '@/interfaces/store-interfaces/event-emitter.interface';
import { Film } from '@/modules/Rhizome/interfaces/film.interface';

@Component({
  directives: {
    ClickOutside
  }
})
export default class SelectKeyword extends Vue {
  open = false;
  loading = false;
  showCount = true;

  keywords = [];

  selected: string | null = null;

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  get controlsBelow() {
    return this.$store.state.rhizome.controlsBelow;
  }

  get numberItems(): number {
    return this.$store.state.rhizome.filmsList.length;
  }

  get filterByKeyword(): Film.IKeyword {
    return this.$store.state.rhizome.filterByKeyword;
  }

  async mounted() {
    this.refreshKeywords();

    bus.$on(EventEmitter.Events.SET_KEYWORD, this.setSelected)
    bus.$on(EventEmitter.Events.FILTER_APPLIED, this.onFilterApplied)
  }

  destroyed() {
    bus.$off(EventEmitter.Events.SET_KEYWORD, this.setSelected)
    bus.$off(EventEmitter.Events.FILTER_APPLIED, this.onFilterApplied)
  }

  async refreshKeywords() {
    this.loading = true;
    const mainPageContent = await this.$store.dispatch("contentPage/getPageContent", {page: RouterStore.ROUTE_NAME.MAIN_PAGE});
    this.keywords = mainPageContent.content.find(block => block.type === 'keyWords')?.keyWords.words.slice(0, 24) || []
    this.loading = false;
  }

  addPressedStyle(event) {
    if (this.isKiosk) {
      event.target.classList.add('pressed');
    }
  }

  removePressedStyle(event) {
    if (this.isKiosk) {
      event.target.classList.remove('pressed');
    }
  }

  setSelected(obj: Film.IKeyword | null) {
      if (obj === null) {
       this.clearFilter()
        return
      }

      this.selected = obj.value
      this.showCount = false

      this.$store.commit('rhizome/setPropertyInState', { name: 'filterByKeywordName', value: obj.value });
      bus.$emit('filterListKeyword', {keywordID: obj.id, keywordValue: obj.value});
    }

  onToggle() {
    this.open = !this.open
  }

  onFilterApplied() {
    this.showCount = true;
  }

  onClose() {
    this.open = false
  }

  handleSelect(obj) {
    this.selected = obj.keyword
    this.showCount = false

    this.$store.commit('rhizome/setPropertyInState', { name: 'filterByKeywordName', value: obj.keyword });
    bus.$emit('filterListKeyword', {keywordID: obj.entity_id, keywordValue: obj.keyword});

    this.open = false
  }

  clearAll() {
    this.clearFilter()
    this.open = false
  }

  clearFilter() {
    if (this.selected === null) {
      return
    }

    this.selected = null
    this.showCount = false

    if (this.filterByKeyword) {
      this.$store.commit('rhizome/setPropertyInState', { name: 'filterByKeyword', value: null });
    }
    this.$store.commit('rhizome/setPropertyInState', { name: 'filterByKeywordName', value: '' });

    this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: false });
    bus.$emit('filterListKeyword', '');
  }

  onClickOutside(event) {
    if (event.target === this.$refs.button) {
      return
    }

    this.open = false
  }
}
